import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { convertToAMPM, dateRangeOptions } from "../../utilities";
import { Link } from "react-router-dom";
import {
  parse,
  format,
  isValid,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { getDriverTravelHistory } from "../../services/Driverservice";
const DriverRidingHistory = () => {
  const { id } = useParams();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedOption, setSelectedOption] = useState(dateRangeOptions[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [param, setParam] = useState({
    query: "",
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });
  useEffect(() => {
    setLoading(true);
    getDriverTravelHistory(id, param)
      .then((res) => {
        setData(res?.data?.results || []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param]);
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
    }));
  };
  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({ ...param, start_date: "", end_date: "" });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
    });
  };
  return (
    <div>
      <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-3 py-2">
        <div className="flex-fill flex-md-grow-0">
          {/* <small className="text-dark">Search here</small> */}
          <DebounceSearchInput handleSearchChange={handleSearchChange} />
        </div>
        <div className="d-flex flex-column flex-md-row gap-2">
          {showDatePicker && (
            <div className="flex-fill flex-md-grow-0">
              {/* <small className="text-dark">Select Date</small> */}
              <DatePicker
                selectsRange
                startDate={
                  param?.start_date ? new Date(param.start_date) : null
                }
                endDate={param?.end_date ? new Date(param.end_date) : null}
                onChange={(update) => {
                  const [start, end] = update;
                  setParam((prev) => ({
                    ...prev,
                    start_date: start ? format(start, "yyyy-MM-dd") : "",
                    end_date: end ? format(end, "yyyy-MM-dd") : "",
                    page: 1,
                  }));
                }}
                isClearable
                placeholderText="Select date range"
                className="form-control"
                style={{
                  fontSize: "0.5rem",
                }}
                popperProps={{
                  modifiers: [
                    {
                      name: "zIndex",
                      enabled: true,
                      phase: "beforeWrite",
                      fn({ state }) {
                        state.styles.popper.zIndex = 999;
                      },
                    },
                  ],
                }}
              />
            </div>
          )}
          <div className="flex-fill flex-md-grow-0">
            {/* <small className="text-dark">Select Period</small> */}
            <Select
              options={dateRangeOptions}
              onChange={handleSelectChange}
              placeholder="Select Period"
              className="react-select"
              classNamePrefix="select"
              isClearable
              value={selectedOption}
              styles={{
                menu: (provided) => ({
                  ...provided,
                  zIndex: 999,
                }),
              }}
            />
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <div className="text-center my-3">
            <Spinner animation="border" />
          </div>
        ) : data.length == 0 ? (
          <div className="text-center my-3">No Data Found</div>
        ) : (
          <div className="table-responsive">
            {" "}
            <table className="table fs-6 mb-0">
              <thead className="table-light custom-thead">
                <tr>
                  <th>Bus</th>
                  <th>Route</th>
                  <th>Shift</th>
                  <th>Schedule</th>
                  <th>Actual</th>
                  <th>Mode</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item) => {
                  const statusLower = item?.status?.toLowerCase();
                  const tripModeClass =
                    item?.trip_mode?.toLowerCase() === "pickup"
                      ? "text-bg-success-soft"
                      : "text-bg-info-soft";
                  return (
                    <tr key={item.id}>
                      <td><Link to={`/bus/${item?.bus?.id}`} className="text-primary cursor-pointer fw-semibold">{item?.bus?.number_plate}</Link></td>
                      <td><Link to={`/route/${item?.route?.id}`} className="text-primary cursor-pointer fw-semibold">{item?.route?.name || "N/A"}</Link></td>
                      <td><Link to={`/shift/${item?.shift?.id}`} className="text-primary cursor-pointer fw-semibold">{item?.shift?.name || "N/A"}</Link></td>
                      <td>
                        {item?.stop_schedule_time
                          ? convertToAMPM(item?.stop_schedule_time)
                          : "N/A"}
                      </td>
                      <td>
                        {item?.actual_time
                          ? convertToAMPM(item?.actual_time)
                          : "N/A"}
                      </td>
                      <td>
                        <span
                          className={`badge ${tripModeClass} text-capitalize`}
                        >
                          {item?.trip_mode || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            statusLower.includes("delayed")
                              ? "text-bg-danger-soft"
                              : statusLower.includes("not reached")
                              ? "text-bg-info-soft"
                              : "text-bg-success-soft"
                          }`}
                          style={{ fontSize: "12px" }}
                        >
                          {item?.status || "N/A"}
                        </span>
                      </td>
                      <td>
                        {item?.created_at
                          ? format(item?.created_at, "dd MMM,yyyy")
                          : "N/A"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default DriverRidingHistory;
